import React, { useEffect, useState } from 'react';
import { Section } from '../ui/Section';
import { Clock, AlertTriangle, Eye } from 'lucide-react';
import { motion } from 'framer-motion';
export function UrgencySection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  const [viewers, setViewers] = useState(34);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    // Random viewer count fluctuation
    const viewerTimer = setInterval(() => {
      setViewers(prev => {
        const change = Math.floor(Math.random() * 5) - 2; // -2 to +2
        return Math.max(23, Math.min(47, prev + change));
      });
    }, 3000);
    return () => {
      clearInterval(timer);
      clearInterval(viewerTimer);
    };
  }, []);
  const FlipCard = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-378">
      <div className="bg-[#2C1810] text-white p-4 rounded-lg min-w-[70px] md:min-w-[90px] relative border-b-4 border-black/30 shadow-lg" data-id="element-379">
        <div className="absolute top-1/2 left-0 w-full h-[1px] bg-black/40" data-id="element-380"></div>
        <span className="text-3xl md:text-4xl font-mono font-bold block relative z-10" data-id="element-381">
          {String(value).padStart(2, '0')}
        </span>
      </div>
      <span className="text-xs uppercase opacity-80 mt-2 font-bold tracking-wider" data-id="element-382">
        {label}
      </span>
    </div>;
  return <div className="bg-gradient-to-br from-[#C1440E] to-[#8a300a] text-white py-8 relative overflow-hidden" data-id="element-383">
      {/* Background Pulse */}
      <div className="absolute inset-0 bg-red-500/10 animate-pulse" data-id="element-384"></div>

      <Section data-id="element-385">
        {/* Layer 12: Urgency */}
        <div className="text-center mb-4 relative z-10" data-id="element-386">
          <div className="flex items-center justify-center gap-2 mb-4 bg-black/20 inline-block px-4 py-2 rounded-full backdrop-blur-sm border border-white/10" data-id="element-387">
            <AlertTriangle className="w-5 h-5 text-[#D4A017] animate-pulse" data-id="element-388" />
            <span className="font-bold text-[#D4A017] uppercase tracking-wider text-sm" data-id="element-389">
              Precio de lanzamiento termina pronto
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold mb-5 leading-tight" data-id="element-390">
            Este botiquín se vende normalmente en{' '}
            <span className="line-through opacity-60 decoration-2" data-id="element-391">$19.97</span>
            .
            <br data-id="element-392" />
            <span className="text-[#D4A017] text-4xl block mt-2 drop-shadow-md" data-id="element-393">
              Hoy: $6.97.
            </span>
          </h2>

          <div className="flex justify-center items-start gap-2 md:gap-4 text-center mb-6" data-id="element-394">
            <FlipCard value={timeLeft.hours} label="Horas" data-id="element-395" />
            <span className="text-4xl font-bold mt-2 opacity-50" data-id="element-396">:</span>
            <FlipCard value={timeLeft.minutes} label="Min" data-id="element-397" />
            <span className="text-4xl font-bold mt-2 opacity-50" data-id="element-398">:</span>
            <FlipCard value={timeLeft.seconds} label="Seg" data-id="element-399" />
          </div>

          {/* Scarcity Bar */}
          <div className="max-w-md mx-auto mb-5" data-id="element-400">
            <div className="flex justify-between text-xs font-bold mb-1 uppercase tracking-wide opacity-90" data-id="element-401">
              <span data-id="element-402">Copias Disponibles</span>
              <span data-id="element-403">14 de 50</span>
            </div>
            <div className="h-3 bg-black/30 rounded-full overflow-hidden border border-white/10" data-id="element-404">
              <motion.div initial={{
              width: '100%'
            }} animate={{
              width: '28%'
            }} transition={{
              duration: 2,
              ease: 'easeOut'
            }} className="h-full bg-[#D4A017] shadow-[0_0_10px_#D4A017]" data-id="element-405"></motion.div>
            </div>
            <p className="text-xs mt-2 flex items-center justify-center gap-1 opacity-80" data-id="element-406">
              <Eye className="w-3 h-3" data-id="element-407" />
              <span className="font-bold" data-id="element-408">{viewers} personas</span> están viendo
              esta oferta ahora
            </p>
          </div>

          <div className="bg-white/10 p-4 rounded-xl text-left max-w-xl mx-auto border border-white/20 backdrop-blur-sm" data-id="element-409">
            <p className="font-bold mb-3 text-center text-lg" data-id="element-410">
              Cada día que esperas es:
            </p>
            <ul className="space-y-2" data-id="element-411">
              {['Una noche más sin dormir.', 'Una tarde más sin poder abrazar a tus hijos sin dolor.', 'Una analítica más con colesterol subiendo.'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-412">
                  <Clock className="w-5 h-5 text-[#D4A017]" data-id="element-413" />
                  <span data-id="element-414">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </Section>
    </div>;
}